import { defineMessages } from 'react-intl';

export default defineMessages({
  commitFileHeading: {
    id: 'frontbucket.repository.commitModal.commitFileHeading',
    description:
      'Label for the heading text shown in the modal window when a user is committing changes to a file',
    defaultMessage: 'Commit changes',
  },
  deleteFileHeading: {
    id: 'frontbucket.repository.commitModal.deleteFileHeading',
    description:
      'Label for the heading text shown in the modal window when a user is deleting a file',
    defaultMessage: 'Delete',
  },
  renameFileHeading: {
    id: 'frontbucket.repository.commitModal.renameFileHeading',
    description:
      'Label for the heading text shown in the modal window when a user is renaming a file',
    defaultMessage: 'Rename',
  },
  commitMessageLabel: {
    id: 'frontbucket.repository.commitModal.commitMessageLabel',
    description:
      'Label for the text field where the user types a description of the commit',
    defaultMessage: 'Commit message',
  },
  pullRequestRequiredTooltip: {
    id: 'frontbucket.repository.commitModal.pullRequestRequiredTooltip',
    description:
      'Tooltip explaining that branch restrictions require changes be made through a pull request',
    defaultMessage:
      'Pull request creation is required based on repository branch restrictions.',
  },
  createPullRequestButton: {
    id: 'frontbucket.repository.commitModal.createPullRequestButton',
    description:
      'Label for button that will submit the form in the modal and create a pull request',
    defaultMessage: 'Create pull request',
  },
  createPullRequestLabel: {
    id: 'frontbucket.repository.commitModal.createPullRequestLabel',
    description:
      'Label for checkbox indicating whether a pull request should be created',
    defaultMessage: 'Create a pull request for this change',
  },
  branchNameLabel: {
    id: 'frontbucket.repository.commitModal.branchNameLabel',
    description: 'Label for the field where the user chooses a branch name',
    defaultMessage: 'Branch name',
  },
  renameNewPathLabel: {
    id: 'frontbucket.repository.commitModal.renameNewPathLabel',
    description:
      'Label for the field where the user chooses a new name when renaming a file',
    defaultMessage: 'New path',
  },
  deleteFileWarning: {
    id: 'frontbucket.repository.commitModal.deleteWarning',
    description:
      'Message informing users that the delete operation will delete the file from the repository',
    defaultMessage:
      'Committing this change will delete {path} from your repository',
  },
  defaultBranchError: {
    id: 'frontbucket.repository.commitModal.defaultBranchError',
    description:
      'Message informing the user that a default branch could not be found for the repository so they must create a pull request instead',
    defaultMessage:
      'The default branch for your repository could not be determined. You must create a pull request to continue.',
  },
  successFlagCommitLink: {
    id: 'frontbucket.repository.commitModal.successFlag.commitLink',
    description:
      'Link in a flag shown upon a successful commit to edit a file. The link points to the commit containing the changes just made',
    defaultMessage: 'See your commit',
  },
  successFlagChangeFileDescription: {
    id: 'frontbucket.repository.commitModal.successFlag.changeFileDescription',
    description:
      'Body text of the flag shown upon a successful commit to edit a file via the online editor',
    defaultMessage:
      'They now appear as the latest commit on the repository commit list. You can also see what you changed at the individual commit.',
  },
  successFlagChangeFileTitle: {
    id: 'frontbucket.repository.commitModal.successFlag.changeFileTitle',
    description:
      'Main heading of the flag shown upon a successful commit to edit a file via the online editor',
    defaultMessage: 'You successfully committed your changes',
  },
  successFlagDeleteFileDescription: {
    id: 'frontbucket.repository.commitModal.successFlag.deleteFileDescription',
    description:
      'Body text of the flag shown upon a successful commit to delete a file via the online editor',
    defaultMessage:
      'This change appears as the latest commit on the repository commit list. You can also see what you deleted at the individual commit.',
  },
  successFlagDeleteFileTitle: {
    id: 'frontbucket.repository.commitModal.successFlag.deleteFileTitle',
    description:
      'Main heading of the flag shown upon a successful commit to delete a file via the online editor',
    defaultMessage: 'You deleted this file successfully',
  },
  successFlagRenameFileDescription: {
    id: 'frontbucket.repository.commitModal.successFlag.renameFileDescription',
    description:
      'Body text of the flag shown upon a successful commit to rename a file via the online editor',
    defaultMessage:
      'This change appears as the latest commit on the repository commit list. You can also see what you changed at the individual commit.',
  },
  successFlagRenameFileTitle: {
    id: 'frontbucket.repository.commitModal.successFlag.renameFileTitle',
    description:
      'Main heading of the flag shown upon a successful commit to rename a file via the online editor',
    defaultMessage: 'You renamed this file successfully',
  },
});
